import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { InviteFriendsModal } from './ReferralModals';
import { useAuth } from '../contexts/AuthContext';

// Opens the invite modal from any page with ?invite=1 (used by the invite reminder push).
export const InviteDeepLink = () => {
  const { user } = useAuth();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(search);
  if (!user || params.get('invite') !== '1') return null;
  const close = () => {
    params.delete('invite');
    const qs = params.toString();
    navigate(`${pathname}${qs ? `?${qs}` : ''}`, { replace: true });
  };
  return <InviteFriendsModal open onClose={close} />;
};

export default InviteDeepLink;
